module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAUZJREFUOE+tk88rg3Ecx1/PLkSOpLBlWCGX+VH+AGnFXRN2lWUOfuSAcJBxME2OGil3asldid0w0UYPStzUag6eR4/PmsaexZPn8nrqeb9f3+f7S9G97lbgDGtPm6J73WmgyFqfN0OgWyx/1goLhibFHQmajpErqG+B4hI4P5HCxqFwpFvY3AHpFCQussJcwXwEHC7wdUpgYVs4OyjcOgb1GuZ8JoKpMNTUgd+TXxCOwn0Clv0mgvEQVDthrDe/YG0fHpKwGjARTKyLINAjgcXMFGYyUwgdiGBl1ESwtAf2Bug3zhaweSQc7hLuxkC9gek+E4HdBaVlEI9JwNkkTF4KjV1IvcLdVR6BokBtI2jvUOmQwPOjsKJK+KSCzQa3cdDl/H1to/Fh5zRrLvgy0A6a9k3wu+qP1L9cJmPJo0D5H3/iBfB8AF5ldAsK/5YeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jqgl-1.png
// module id = dWKz
// module chunks = 7